import client from "./http.client"
import store from "@/store"
class ObjectTypesService {
  getObjectTypes(params = {}) {
    return client.get(`/api/organizations/${store.state.organization.id}/object-types/`, { params })
  }

  getObjectType(id) {
    return client.get(`/api/organizations/${store.state.organization.id}/object-types/${id}/`)
  }

  updateObjectType(id, data) {
    return client.patch(`/api/organizations/${store.state.organization.id}/object-types/${id}/`, data)
  }
  updateObjectTypeLabel(id, data) {
    return client.post(`/api/organizations/${store.state.organization.id}/object-types/${id}/update-label/`, data)
  }

  deleteObjectType(id) {
    return client.delete(`/api/organizations/${store.state.organization.id}/object-types/${id}/`)
  }

  createObjectType(data) {
    return client.post(`/api/organizations/${store.state.organization.id}/object-types/`, data)
  }
}

export default new ObjectTypesService()
